import { useAuthorizedRoutes } from "pages/router"
import { Navigate } from "react-router"

export function CheckAuthorization() {
	const {
		allowedRoutes: [to],
		isFetched,
	} = useAuthorizedRoutes()

	if (!isFetched) {
		return null
	}

	return <Navigate to={to} replace />
}
